<template>
  <div class="index">
  </div>
</template>

<script>

export default {
  name: "index",
  components:{
  }
}
</script>

<style scoped lang='scss'>
.index{
  width: 100%;
  height: 100%;
  background-image: url('../assets/home.png');
  background-repeat: no-repeat;
  background-size: (100%,100%);
 /* padding: 0;
  width:  100vw;
  height: 100vh;
  background-size: (100vw,100vh); */
}
</style>
